import "cn-next/es/progress/style";
import _Progress from "cn-next/es/progress";
import "cn-next/es/dialog/style";
import _Dialog from "cn-next/es/dialog";
import "cn-next/es/upload/style";
import _Upload from "cn-next/es/upload";
import "cn-next/es/button/style";
import _Button from "cn-next/es/button";
import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import { Fragment } from "react";
import _regeneratorRuntime from "@babel/runtime/regenerator";

/* eslint-disable max-classes-per-file */
import "./style/index.scss";
import React from 'react';
import { componentName } from "../const";
import zhCN from "../locale/zh-CN";
import { getResTemplates, dialogStyle } from "./config";
import { importData } from "./api";

var Import = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Import, _React$Component);

  function Import() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      step: -1,
      // -1 初始阶段 0 导入操作界面  1 导入中  2 导入结果（完成）
      styles: [],
      percent: 0,
      finalTemplate: null,
      res: {},
      start: false,
      hasTemplate: true,
      files: []
    };
    return _this;
  }

  // 变化的值
  Import.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var demoText = props.demoText,
        demoLinkDownload = props.demoLinkDownload,
        uploadProps = props.uploadProps;
    var hasTemplate = !!(demoText || demoLinkDownload || uploadProps !== null && uploadProps !== void 0 && uploadProps.listType);
    var targetStep = -1;

    if (!hasTemplate) {
      targetStep = !state.start ? -1 : Math.max(state.step, 1);
    } else {
      targetStep = !state.start ? -1 : Math.max(state.step, 0);
    }

    return {
      hasTemplate: hasTemplate,
      step: targetStep,
      percent: !state.start ? 0 : state.percent
    };
  };

  var _proto = Import.prototype;

  _proto.onCloce = function onCloce() {
    this.setState({
      start: false,
      files: []
    });

    if (this.props.onClose instanceof Function) {
      this.props.onClose();
    }
  };

  _proto.setStep = function setStep(step) {
    var onStepChange = this.props.onStepChange;
    var targetStep = step;

    if (step === 1) {
      this.goLoading();
    }

    if (step === 2 && this.props.endHandler instanceof Function) {
      targetStep = -1;
      this.props.endHandler(this.state.res);
    }

    this.setState({
      step: targetStep
    });

    if (onStepChange) {
      onStepChange(targetStep);
    }
  };

  _proto.goLoading = function goLoading() {
    var _this2 = this;

    var percent = this.state.percent;
    var randomPercent = 30 * Math.random();
    var randomDuration = Math.max(3000 * Math.random(), 1);
    setTimeout(function () {
      var nextRes = Math.min(percent + randomPercent, 99);

      _this2.setState({
        percent: nextRes
      });

      if (nextRes < 99) {
        _this2.goLoading();
      }
    }, randomDuration);
  };

  _proto.goEnd = function goEnd() {
    var _this3 = this;

    this.setState({
      percent: 100
    });
    setTimeout(function () {
      _this3.setStep(2);
    }, 300);
  };

  _proto.updateSelf = /*#__PURE__*/function () {
    var _updateSelf = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(info) {
      var formData, _res;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              formData = new FormData();

              if (Array.isArray(info)) {
                info.forEach(function (item) {
                  formData.append('files', item, (item === null || item === void 0 ? void 0 : item.name) || '');
                });
              } else {
                formData.append('file', info, (info === null || info === void 0 ? void 0 : info.name) || '');
              }

              _context.next = 5;
              return importData(formData);

            case 5:
              _res = _context.sent;
              return _context.abrupt("return", _res);

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", {
                type: 'failAll',
                errorMessage: _context.t0.message
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    function updateSelf(_x) {
      return _updateSelf.apply(this, arguments);
    }

    return updateSelf;
  }();

  _proto.beforeUpload = function beforeUpload(info) {
    var _this4 = this;

    var _this$props = this.props,
        upload = _this$props.upload,
        transformResponse = _this$props.transformResponse,
        _this$props$beforeUpl = _this$props.beforeUpload,
        beforeUpload = _this$props$beforeUpl === void 0 ? function () {
      return true;
    } : _this$props$beforeUpl,
        _this$props$locale = _this$props.locale,
        locale = _this$props$locale === void 0 ? zhCN : _this$props$locale;
    var updateApi = upload ? upload : this.updateSelf.bind(this);
    var resTemplates = getResTemplates(locale);
    Promise.resolve(beforeUpload(info)).then(function (val) {
      if (val) {
        doUpload.apply(_this4);
      }
    });

    var doUpload = function doUpload() {
      _this4.setStep(1); // 开始loading


      updateApi && updateApi(info).then(function (res) {
        res = transformResponse instanceof Function ? transformResponse(res) : res;

        _this4.setState({
          finalTemplate: (resTemplates[res.type] || resTemplates.failAll)(_extends({}, res, {
            restart: function restart() {
              _this4.setStep(0); // 重新开始


              _this4.setState({
                files: []
              });
            }
          })),
          res: res
        });

        _this4.goEnd();
      });
    };

    return false;
  };

  _proto.render = function render() {
    var _this5 = this;

    var _this$props2 = this.props,
        _this$props2$locale = _this$props2.locale,
        locale = _this$props2$locale === void 0 ? zhCN : _this$props2$locale,
        startTemplate = _this$props2.startTemplate,
        loadingTemplate = _this$props2.loadingTemplate,
        resultTemplate = _this$props2.resultTemplate,
        _this$props2$tip = _this$props2.tip,
        tip = _this$props2$tip === void 0 ? '' : _this$props2$tip,
        _this$props2$demoLink = _this$props2.demoLinkDownload,
        demoLinkDownload = _this$props2$demoLink === void 0 ? 'javascript:;' : _this$props2$demoLink,
        _this$props2$demoText = _this$props2.demoText,
        demoText = _this$props2$demoText === void 0 ? locale === null || locale === void 0 ? void 0 : locale.importTemplateText : _this$props2$demoText,
        btnProps = _this$props2.btnProps,
        title = _this$props2.title,
        style = _this$props2.style,
        _this$props2$uploadPr = _this$props2.uploadProps,
        uploadProps = _this$props2$uploadPr === void 0 ? {
      accept: 'application/vnd.ms-excel'
    } : _this$props2$uploadPr,
        _this$props2$onDemoCl = _this$props2.onDemoClick,
        onDemoClick = _this$props2$onDemoCl === void 0 ? function () {} : _this$props2$onDemoCl,
        _this$props2$visible = _this$props2.visible,
        customVisible = _this$props2$visible === void 0 ? true : _this$props2$visible;
    var _this$state = this.state,
        step = _this$state.step,
        percent = _this$state.percent,
        finalTemplate = _this$state.finalTemplate,
        hasTemplate = _this$state.hasTemplate,
        files = _this$state.files;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Button, _extends({
      size: "small",
      onClick: function onClick() {
        _this5.setState({
          start: true
        });
      }
    }, btnProps), (btnProps === null || btnProps === void 0 ? void 0 : btnProps.children) || (locale === null || locale === void 0 ? void 0 : locale["import"])), /*#__PURE__*/React.createElement(_Dialog, {
      title: title,
      visible: customVisible && step === 0,
      footerActions: [],
      onClose: function onClose() {
        _this5.onCloce();
      },
      style: _extends({
        width: 400
      }, dialogStyle, style || {})
    }, startTemplate || /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 40,
        textAlign: 'center'
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Upload, _extends({
      className: "cnc-upload-progress-main",
      onChange: function onChange(tmpFiles) {
        _this5.setState({
          files: tmpFiles
        });
      },
      action: "",
      beforeUpload: function beforeUpload(file) {
        return _this5.beforeUpload(file);
      },
      style: {
        display: 'inline-block'
      }
    }, uploadProps), /*#__PURE__*/React.createElement(_Button, {
      type: "primary"
    }, locale === null || locale === void 0 ? void 0 : locale.importFile)), hasTemplate && !!(files !== null && files !== void 0 && files.length) && /*#__PURE__*/React.createElement("div", {
      className: "cnc-upload-progress-batch-upload-btn"
    }, /*#__PURE__*/React.createElement(_Button, {
      type: "primary",
      onClick: function onClick() {
        return _this5.beforeUpload(files);
      }
    }, locale === null || locale === void 0 ? void 0 : locale.upload))), demoText !== false && /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 19,
        marginBottom: 3
      }
    }, locale === null || locale === void 0 ? void 0 : locale.forExample( /*#__PURE__*/React.createElement("a", {
      style: {
        color: '#0055FF'
      },
      href: demoLinkDownload,
      onClick: onDemoClick
    }, demoText))), demoText !== false && /*#__PURE__*/React.createElement("div", null, tip || (locale === null || locale === void 0 ? void 0 : locale.tip)))), /*#__PURE__*/React.createElement(_Dialog, {
      title: title,
      visible: customVisible && step === 1,
      footerActions: [],
      onClose: function onClose() {
        _this5.onCloce();
      },
      style: _extends({
        width: 400
      }, dialogStyle, style || {})
    }, loadingTemplate || /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 40,
        textAlign: 'center'
      }
    }, /*#__PURE__*/React.createElement("div", null, locale === null || locale === void 0 ? void 0 : locale.importing), /*#__PURE__*/React.createElement(_Progress, {
      percent: percent,
      size: "small"
    }))), /*#__PURE__*/React.createElement(_Dialog, {
      title: title,
      visible: customVisible && step === 2 && !(this.props.endHandler instanceof Function),
      footerActions: [],
      onClose: function onClose() {
        _this5.onCloce();
      },
      style: _extends({
        width: 400
      }, dialogStyle, style || {})
    }, resultTemplate || /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 20,
        textAlign: 'center'
      }
    }, finalTemplate)));
  };

  return Import;
}(React.Component);

function View(props) {
  var jsonProps = props.jsonProps;
  var targetProps = jsonProps ? _extends({}, props, jsonProps) : props;
  return /*#__PURE__*/React.createElement(Import, targetProps);
}

View.displayName = componentName;
export default View;